import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 12a9.96 9.96 0 0 1-1 4.364V19a2 2 0 0 1-2 2h-2.636c-1.319.64-2.8 1-4.364 1-5.523 0-10-4.477-10-10S6.477 2 12 2s10 4.477 10 10m-2 0a7.96 7.96 0 0 1-1 3.876V18a1 1 0 0 1-1 1h-2.124A8 8 0 1 1 20 12",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M7 10a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1"
    }
  )
);
var SvgSmsOutboundOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SmsOutboundOutlined_default = SvgSmsOutboundOutlined;

export { SmsOutboundOutlined_default as default };
